import Card from 'components/card';
import BarChart from 'components/charts/BarChart';
import {barChartOptionsCustomCDTrends} from 'variables/charts';
import {MdBarChart} from 'react-icons/md';
import {AccountSummaryResponse, WalletAggregateTrendData} from '../../../../stores/types';
import {parseJSON} from 'date-fns';
import React, {useEffect} from 'react';
import format from 'date-fns/format';

const getReportData = (trendData: WalletAggregateTrendData[], categoriesAsMonths = false) => {
  const categories = trendData
    .map((m) => {
      const parsed = parseJSON(m.transactionDate);
      return categoriesAsMonths ? format(parsed, "MMM ''yy") : parsed.toLocaleDateString();
    })
    .filter((elem, index, self) => index === self.indexOf(elem));

  const dataMap = {};
  trendData.forEach((c) => (dataMap[c.transactionDate] = {credit: 0, debit: 0}));
  trendData.forEach((m) => {
    if (m.transactionType === 'CREDIT') {
      dataMap[m.transactionDate].credit = m.amount;
    } else {
      dataMap[m.transactionDate].debit = m.amount;
    }
  });

  const barChartData = [
    {
      name: 'Credit',
      data: Object.values(dataMap).map((m: any) => m.credit),
      color: '#4A9DFF',
      type: 'column',
    },
    {
      name: 'Debit',
      data: Object.values(dataMap).map((m: any) => m.debit),
      color: '#FEC17A',
      type: 'column',
    },
    {
      name: 'Debit % Change',
      data: Object.values(dataMap).map((m: any, idx, arr: any[]) => {
        if (idx === 0) {
          return 0;
        } else {
          const val = ((m.debit - arr[idx - 1].debit) / m.debit) * 100;
          return (Number.isFinite(val) ? val : 0).toFixed(2);
        }
      }),
      color: '#6844AD',
      type: 'line',
    },
  ];
  return {categories, barChartData};
};

const WeeklyRevenue = (props: {summary: AccountSummaryResponse}) => {
  const [reportType, setReportType] = React.useState<string>();

  useEffect(() => {
    setReportType('monthly');
  }, []);

  const {categories, barChartData} = reportType === 'daily' ? getReportData(props.summary.dailyCDLastNDays) : getReportData(props.summary.monthlyCDTrend, true);

  return (
    <Card extra="flex flex-col bg-white w-full rounded-3xl py-6 px-2 text-center">
      <div className="mb-auto flex items-center justify-between px-6">
        <h2 className="text-lg font-bold text-navy-700 dark:text-white">{reportType === 'monthly' ? 'Monthly' : 'Daily'} Flows</h2>
        <button
          onClick={() => setReportType((v) => (v === 'monthly' ? 'daily' : 'monthly'))}
          className="!linear z-[1] flex items-center justify-center rounded-lg bg-lightPrimary p-2 text-sm font-bold !transition !duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10"
        >
          {reportType === 'monthly' ? 'Daily' : 'Monthly'}
        </button>
      </div>

      <div className="md:mt-16 lg:mt-0">
        <div className="h-[250px] w-full xl:h-[350px]">
          {categories.length > 0 && <BarChart key={reportType ?? 'x'} chartData={barChartData} chartOptions={barChartOptionsCustomCDTrends(categories, reportType === 'monthly')} />}
        </div>
      </div>
    </Card>
  );
};

export default WeeklyRevenue;
